function Promo() {
  return (
    <section className="promo">
      <div className="promo__text">
        <h1 className="promo__title">
          A WORLD
          <br />
          IN FRAMES
        </h1>
        <h2 className="promo__subtitle">
          From mountain landscapes and quiet streets to distant cities — a
          growing collection of places and impressions
        </h2>
      </div>
    </section>
  );
}

export default Promo;
